import * as S from './CategoryProductSection.styles'

type Props = {
  title: string
  description: string
}

function CategoryProductSection({ title, description }: Props) {
  return (
    <S.Container>
      <S.Title>
        {title.charAt(0).toUpperCase() + title.slice(1).toLowerCase()}
      </S.Title>
      <S.Description>{description}</S.Description>
    </S.Container>
  )
}

export default CategoryProductSection
